import axios from "axios";

export const BASE_URL =
  process.env.REACT_APP_BASE_URL || "http://localhost:8080/api/";
export const FRONT_URL =
  process.env.REACT_APP_FRONT_URL || "http://localhost:3000/";

export const SHARE_TOKEN_STORAGE_KEY = "k2g_share_token";

// Attach X-Share-Token (for guests viewing a shared report) and
// X-Admin-User-Id (for logged-in admins) on every request. The backend's
// reportAccess middleware reads these headers — there's no JWT layer.
axios.interceptors.request.use((config) => {
  try {
    const shareToken = sessionStorage.getItem(SHARE_TOKEN_STORAGE_KEY);
    if (shareToken) config.headers["X-Share-Token"] = shareToken;

    const userRaw = localStorage.getItem("userK2G");
    if (userRaw) {
      const u = JSON.parse(userRaw);
      if (u && u.rol === "admin" && u._id) {
        config.headers["X-Admin-User-Id"] = u._id;
      }
    }
  } catch (_) {
    // best-effort header injection; never block the request
  }
  return config;
});

//AUTH

export const loginUser = async (data) => {
  try {
    const resp = await axios.post(BASE_URL + "auth/login", data);
    return resp.data;
  } catch (error) {
    //TO DO: HANDLE ERROR
    return {
      user: undefined,
      msg: error.response.data.msg,
    };
  }
};

export const loginAdmin = async (data) => {
  try {
    const resp = await axios.post(BASE_URL + "auth/loginAdmin", data);
    return resp.data;
  } catch (error) {
    //TO DO: HANDLE ERROR
    return {
      user: undefined,
      msg: error.response.data.msg,
    };
  }
};

// OTP Authentication
export const requestOTP = async (email) => {
  try {
    const resp = await axios.post(BASE_URL + "auth/request-otp", { email });
    return resp.data;
  } catch (error) {
    return {
      success: false,
      msg: error.response?.data?.msg || "Failed to send verification code"
    };
  }
};

export const verifyOTP = async (email, code) => {
  try {
    const resp = await axios.post(BASE_URL + "auth/verify-otp", { email, code });
    return resp.data;
  } catch (error) {
    return {
      user: undefined,
      msg: error.response?.data?.msg || "Verification failed"
    };
  }
};

// Forgot Password
export const forgotPassword = async (email) => {
  try {
    const resp = await axios.post(BASE_URL + "auth/forgot-password", { email });
    return resp.data;
  } catch (error) {
    return {
      success: false,
      msg: error.response?.data?.msg || "Failed to send reset code"
    };
  }
};

export const resetPassword = async (email, code, newPassword) => {
  try {
    const resp = await axios.post(BASE_URL + "auth/reset-password", { email, code, newPassword });
    return resp.data;
  } catch (error) {
    return {
      success: false,
      msg: error.response?.data?.msg || "Failed to reset password"
    };
  }
};

//USER
export const getAllUsersAdmin = async () => {
  try {
    const resp = await axios.get(BASE_URL + `user/allAdmin`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getUserEvalInfo = async (userId) => {
  try {
    const resp = await axios.get(BASE_URL + `user/${userId}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getProfileInfo = async (userId) => {
  try {
    const resp = await axios.get(BASE_URL + `user/profileAdmin/${userId}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const createUser = async (data) => {
  try {
    const resp = await axios.post(BASE_URL + "user/", data);
    return resp.data;
  } catch (error) {
    //TO DO: HANDLE ERROR
    return {
      user: undefined,
      msg: error.response.data.msg,
    };
  }
};

export const createUserWithAssessments = async (data) => {
  try {
    const resp = await axios.post(BASE_URL + "user/withAssessments", data);
    return resp.data;
  } catch (error) {
    return {
      user: undefined,
      msg: error.response?.data?.msg || "Error creating user",
    };
  }
};

export const updateUser = async (userId, data) => {
  try {
    const resp = await axios.put(BASE_URL + `user/${userId}`, data);
    return resp.data;
  } catch (error) {
    //TO DO: HANDLE ERROR
    return {
      user: undefined,
      msg: error.response.data.msg,
    };
  }
};

export const getAllAdmins = async () => {
  try {
    const resp = await axios.get(BASE_URL + "user/admins");
    return resp.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const createAdmin = async (data) => {
  try {
    const resp = await axios.post(BASE_URL + "user/admins", data);
    return resp.data;
  } catch (error) {
    return {
      user: undefined,
      msg: error.response?.data?.msg || "Error creating admin",
    };
  }
};

export const deleteAdmin = async (adminId) => {
  try {
    const resp = await axios.delete(BASE_URL + `user/admins/${adminId}`);
    return resp.data;
  } catch (error) {
    return {
      success: false,
      msg: error.response?.data?.msg || "Error deleting admin",
    };
  }
};

export const deleteUser = async (userId) => {
  try {
    const resp = await axios.delete(BASE_URL + `user/${userId}`);
    return resp.data;
  } catch (error) {
    return {
      success: false,
      msg: error.response?.data?.msg || "Error deleting user",
    };
  }
};

//USER INFO
export const saveCreateForm = async (id, data) => {
  try {
    const resp = await axios.put(BASE_URL + `user/infoByUserId/${id}`, data);
    return resp.data;
  } catch (error) {
    console.log(error);
    if (error.response.data.error.codeName === "DuplicateKey") {
      return {
        status: false,
        msg: "Email already exists, please change your email or contact and administrator.",
      };
    }
    return undefined;
  }
};

//ASSESSMENTS
export const getAllAssessment = async () => {
  try {
    const resp = await axios.get(BASE_URL + `assessment/`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getAllAssessmentByUser = async (userId) => {
  try {
    const resp = await axios.get(BASE_URL + `assessment/user/${userId}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getAllForMyAssessment = async () => {
  try {
    const resp = await axios.get(BASE_URL + `assessment/myAssessments`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getisCompletedAssessment = async (assessmentId, userId) => {
  try {
    const resp = await axios.get(
      BASE_URL + `assessment/completeAssessment/${assessmentId}/${userId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return {
      isValid: false,
      slug: {
        last: "",
        pos: 0,
      },
    };
  }
};

export const getisCompletedAssessmentTIM = async (
  assessmentId,
  userId,
  groupId,
) => {
  try {
    const resp = await axios.get(
      BASE_URL +
      `assessment/completeAssessment/${assessmentId}/${userId}/${groupId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return {
      isValid: false,
      slug: {
        last: "",
        pos: 0,
      },
    };
  }
};

export const getisCompletedAssessment360 = async (
  assessmentId,
  userId,
  ownerId,
) => {
  try {
    const resp = await axios.get(
      BASE_URL +
      `assessment/360/completeAssessment/${assessmentId}/${userId}/${ownerId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return {
      isValid: false,
      slug: {
        last: "",
        pos: 0,
      },
    };
  }
};

export const checkIsInAssessment = async (assessmentId, userId) => {
  try {
    const resp = await axios.get(
      BASE_URL + `assessment/isInAssessment/${assessmentId}/${userId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return {
      msg: "Error",
      isInAssessment: false,
    };
  }
};

export const getUsersToAddInAssessment = async (assessmentId) => {
  try {
    const resp = await axios.get(
      BASE_URL + `assessment/userToAdd/${assessmentId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const updateAssessment = async (id, data) => {
  try {
    const resp = await axios.put(BASE_URL + `assessment/${id}`, data);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const sendSelfLaunchEmails = async (assessmentId, data) => {
  try {
    const resp = await axios.post(
      BASE_URL + `assessment/${assessmentId}/sendLaunchEmails`,
      data,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return { error: true, msg: error.response?.data?.msg || "Failed" };
  }
};

export const sendSelfReminderEmails = async (assessmentId, data) => {
  try {
    const resp = await axios.post(
      BASE_URL + `assessment/${assessmentId}/sendReminderEmails`,
      data,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return { error: true, msg: error.response?.data?.msg || "Failed" };
  }
};

export const deleteUserFromAssessment = async (assessmentId, userId) => {
  try {
    const resp = await axios.delete(
      BASE_URL + `assessment/${assessmentId}/users/${userId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return {
      success: false,
      msg: error.response?.data?.msg || "Error deleting user from assessment",
    };
  }
};

// Self-assessment groups (LIM Self / MIM Self)
export const getSelfGroupsByCategory = async (category) => {
  try {
    const resp = await axios.get(BASE_URL + `selfGroup/category/${category}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return { error: true, msg: error.response?.data?.msg || "Failed" };
  }
};

export const createSelfGroup = async (data) => {
  try {
    const resp = await axios.post(BASE_URL + `selfGroup`, data);
    return resp.data;
  } catch (error) {
    console.log(error);
    return { error: true, msg: error.response?.data?.msg || "Failed" };
  }
};

export const updateSelfGroup = async (groupId, data) => {
  try {
    const resp = await axios.put(BASE_URL + `selfGroup/${groupId}`, data);
    return resp.data;
  } catch (error) {
    console.log(error);
    return { error: true, msg: error.response?.data?.msg || "Failed" };
  }
};

export const deleteSelfGroup = async (groupId) => {
  try {
    const resp = await axios.delete(BASE_URL + `selfGroup/${groupId}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return { error: true, msg: error.response?.data?.msg || "Failed" };
  }
};

export const addMembersToSelfGroup = async (groupId, userIds) => {
  try {
    const resp = await axios.post(BASE_URL + `selfGroup/${groupId}/members`, {
      userIds,
    });
    return resp.data;
  } catch (error) {
    console.log(error);
    return { error: true, msg: error.response?.data?.msg || "Failed" };
  }
};

export const removeMemberFromSelfGroup = async (groupId, userId) => {
  try {
    const resp = await axios.delete(
      BASE_URL + `selfGroup/${groupId}/members/${userId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return { error: true, msg: error.response?.data?.msg || "Failed" };
  }
};

export const getAvailableUsersForSelfGroup = async (groupId, assessmentId) => {
  try {
    const resp = await axios.get(
      BASE_URL + `selfGroup/${groupId}/availableUsers/${assessmentId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return { error: true, msg: error.response?.data?.msg || "Failed" };
  }
};

export const sendSelfGroupLaunchEmails = async (groupId, data) => {
  try {
    const resp = await axios.post(
      BASE_URL + `selfGroup/${groupId}/sendLaunchEmails`,
      data,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return { error: true, msg: error.response?.data?.msg || "Failed" };
  }
};

export const sendSelfGroupReminderEmails = async (groupId, data) => {
  try {
    const resp = await axios.post(
      BASE_URL + `selfGroup/${groupId}/sendReminderEmails`,
      data,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return { error: true, msg: error.response?.data?.msg || "Failed" };
  }
};

export const checkAssessment = async (assessmentSlug, userEvalId, userId) => {
  try {
    const resp = await axios.get(
      BASE_URL + `360/getAssessment/${assessmentSlug}/${userEvalId}/${userId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return {
      assessment: undefined,
      msg: error.response?.data?.msg || "Error loading assessment",
    };
  }
};

export const update360AssessmentCompleted = async (data) => {
  try {
    const resp = await axios.put(BASE_URL + `360/completed`, data);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

//BLOCK

export const getBlockStatus = async (
  blockId,
  assessmentId,
  userId,
  is360 = false,
) => {
  try {
    if (is360) {
      const resp = await axios.get(
        BASE_URL + `block/answers360/${blockId}/${assessmentId}/${userId}`,
      );
      return resp.data;
    } else {
      const resp = await axios.get(
        BASE_URL + `block/answers/${blockId}/${assessmentId}/${userId}`,
      );
      return resp.data;
    }
  } catch (error) {
    console.log(error);
    return {
      completed: false,
    };
  }
};

export const getBlockStatus360 = async (blockId, assessmentId, userId) => {
  try {
    const resp = await axios.get(
      BASE_URL + `block/answers/360/${blockId}/${assessmentId}/${userId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return {
      completed: false,
    };
  }
};

export const getBlockStatusTIM = async (
  blockId,
  assessmentId,
  userId,
  groupId,
) => {
  try {
    const resp = await axios.get(
      BASE_URL +
      `block/answers/${blockId}/${assessmentId}/${userId}/${groupId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return {
      completed: false,
    };
  }
};

//ANSWERS
export const createAnswer = async (data) => {
  try {
    const resp = await axios.post(BASE_URL + `answer/`, data);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const updateAnswer = async (id, data) => {
  try {
    const resp = await axios.put(BASE_URL + `answer/${id}`, data);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const createBlockAnswers = async (data) => {
  try {
    const resp = await axios.post(BASE_URL + `answer/block`, data);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const updateBlockAnswers = async (data) => {
  try {
    const resp = await axios.put(BASE_URL + `answer/block`, data);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getAnswersByBlockAndUser = async (idBlock, idUser) => {
  try {
    const resp = await axios.get(
      BASE_URL + `answer/blockUser/${idBlock}/${idUser}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getExtraAnswer = async (slug, idUser) => {
  try {
    const resp = await axios.get(BASE_URL + `answer/extra/${slug}/${idUser}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getExtraAnswerBySlug = async (slug) => {
  try {
    const resp = await axios.get(BASE_URL + `answer/extra-by-slug/${slug}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getAnswersByBlockAndUser360 = async (idBlock, idUser) => {
  try {
    const resp = await axios.get(
      BASE_URL + `answer/360/blockUser/${idBlock}/${idUser}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getAnswersByBlockAndUserTIM = async (idBlock, idUser, idGroup) => {
  try {
    const resp = await axios.get(
      BASE_URL + `answer/blockUser/${idBlock}/${idUser}/${idGroup}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getAnswersByBlock360 = async (idBlock, idUser, idOwner) => {
  try {
    const resp = await axios.get(
      BASE_URL + `answer/360/${idBlock}/${idUser}/${idOwner}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getReportInfoTIM = async (groupId, blockId) => {
  try {
    const resp = await axios.get(
      BASE_URL + `answer/report/tim/${groupId}/${blockId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getReportInfoTIMAll = async (groupId) => {
  try {
    const resp = await axios.get(BASE_URL + `answer/report/timAll/${groupId}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

// Admin report-editor overlay (per-team curation of TIM / E-TIM report text +
// verbatim comments). The request interceptor attaches X-Admin-User-Id /
// X-Share-Token, so reads follow the same access rules as the report data and
// writes are gated to admins server-side.
export const getReportOverride = async (groupId) => {
  try {
    const resp = await axios.get(BASE_URL + `report-override/${groupId}`);
    return resp.data?.override || null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const saveReportOverride = async (groupId, overlay) => {
  try {
    const resp = await axios.put(BASE_URL + `report-override/${groupId}`, overlay);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getReportInfoAssessmentAll = async (slug, userId) => {
  try {
    const resp = await axios.get(
      BASE_URL + `answer/report/assessmentAll/${slug}/${userId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getReportInfo360AssessmentAll = async (slug, userId, groupId) => {
  try {
    const resp = await axios.get(
      BASE_URL + `answer/report/assessment360All/${slug}/${userId}/${groupId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getReportInfo360 = async (userId, groupId, blockId, slug) => {
  try {
    const resp = await axios.get(
      BASE_URL + `answer/report/360/${slug}/${groupId}/${blockId}/${userId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getCompleteDate = async (userId, assessmentSlug, groupId) => {
  try {
    const url = BASE_URL + `answer/report/completeDate/${assessmentSlug}/${userId}`;
    const resp = await axios.get(groupId ? `${url}?groupId=${groupId}` : url);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

//QUESTIONS
export const updateQuestion = async (id, data) => {
  try {
    const resp = await axios.put(BASE_URL + `question/${id}`, data);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const createQuestion = async (data) => {
  try {
    const resp = await axios.post(BASE_URL + `question/`, data);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const updateBlock = async (id, data) => {
  try {
    const resp = await axios.put(BASE_URL + `block/${id}`, data);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

//COMPANIES

export const getAllCompanies = async () => {
  try {
    const resp = await axios.get(BASE_URL + `company/`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getCompaniesByCategory = async (category) => {
  try {
    const resp = await axios.get(BASE_URL + `company/category/${category}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const createCompany = async (data) => {
  try {
    const resp = await axios.post(BASE_URL + `company/`, data);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const updateCompany = async (companyId, data) => {
  try {
    const resp = await axios.put(BASE_URL + `company/${companyId}`, data);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const deleteCompany = async (companyId) => {
  try {
    const resp = await axios.delete(BASE_URL + `company/${companyId}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

//GROUPS

export const getGroupsByCompanyId = async (companyId, category) => {
  try {
    const resp = await axios.get(
      BASE_URL + `group/company/${companyId}/${category}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getTIMCompanyReport = async (companyId) => {
  try {
    const resp = await axios.get(BASE_URL + `answer/report/timCompany/${companyId}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getCompanyById = async (companyId) => {
  try {
    const resp = await axios.get(BASE_URL + `company/${companyId}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const updateBlockInfoText = async (assessmentId, blockId, text) => {
  try {
    const resp = await axios.put(
      BASE_URL + `assessment/${assessmentId}/blockInfo/${blockId}`,
      { text },
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const getCompletedGroups = async (q = "") => {
  try {
    const resp = await axios.get(
      BASE_URL + `group/completed${q ? `?q=${encodeURIComponent(q)}` : ""}`,
    );
    return resp.data?.groups || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getCompletedSelfAssessments = async (q = "") => {
  try {
    const resp = await axios.get(
      BASE_URL +
        `assessment/completed/self${q ? `?q=${encodeURIComponent(q)}` : ""}`,
    );
    return resp.data?.rows || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getGroupsByUserId = async (userId) => {
  try {
    const resp = await axios.get(BASE_URL + `group/user/${userId}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getGroupMembersInfo = async (groupId) => {
  try {
    const resp = await axios.get(BASE_URL + `group/info/${groupId}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return {
      msg: "error",
      data: [],
    };
  }
};

export const getGroupMembers360Info = async (groupId, slug) => {
  try {
    const resp = await axios.get(
      BASE_URL + `group/info/360/${groupId}/${slug}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return {
      msg: "error",
      data: [],
    };
  }
};

export const getUsersNotInGroup = async (groupId) => {
  try {
    const resp = await axios.get(BASE_URL + `group/notUsers/${groupId}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return {
      msg: "error",
      data: [],
    };
  }
};

export const getUsersNotInUserList = async (groupId, ownerId) => {
  try {
    const resp = await axios.get(
      BASE_URL + `group/notUsersList/${groupId}/${ownerId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return {
      msg: "error",
      data: [],
    };
  }
};

export const get360Groups = async (userId, slugAssessment) => {
  try {
    const resp = await axios.get(
      BASE_URL + `group/360/${slugAssessment}/${userId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const createGroup = async (data) => {
  try {
    const resp = await axios.post(BASE_URL + `group/`, data);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const deleteGroup = async (groupId) => {
  try {
    const resp = await axios.delete(BASE_URL + `group/${groupId}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const createAndAddUserToGroup = async (groupId, data) => {
  try {
    const resp = await axios.post(BASE_URL + `group/addUser/${groupId}`, data);
    return resp.data;
  } catch (error) {
    console.log(error);
    return {
      user: undefined,
      msg: error.response.data.msg,
    };
  }
};

export const createAndAddUserToUserList = async (groupId, ownerId, data) => {
  try {
    const resp = await axios.post(
      BASE_URL + `group/addUserList/${groupId}/${ownerId}`,
      data,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return {
      user: undefined,
      msg: error.response.data.msg,
    };
  }
};

export const getGroupById = async (groupId) => {
  try {
    const resp = await axios.get(BASE_URL + `group/${groupId}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const updateGroup = async (id, data) => {
  try {
    const resp = await axios.put(BASE_URL + `group/${id}`, data);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const updateGroup360 = async (groupId, assessmentSlug, data) => {
  try {
    const resp = await axios.put(
      BASE_URL + `group/360/${assessmentSlug}/${groupId}`,
      data,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const updateUserList = async (id, ownerId, data) => {
  try {
    const resp = await axios.put(
      BASE_URL + `group/updateUserList/${id}/${ownerId}`,
      data,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const deleteUserFromGroup = async (id, userId, data = {}) => {
  try {
    const resp = await axios.put(
      BASE_URL + `group/member/${id}/${userId}`,
      data,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const deleteUserFromUserEvalList = async (id, userId, ownerId) => {
  try {
    const resp = await axios.put(
      BASE_URL + `group/userList/${id}/${userId}/${ownerId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

//CSV

export const uploadCsv = async (data) => {
  try {
    const resp = await axios.post(BASE_URL + "upload/csv/tim", data, {
      headers: {
        "Contect-Type": "multipart/form-data",
      },
    });
    return resp.data;
  } catch (error) {
    console.log(error);
    return;
  }
};

export const createAndAddMultipleUsersToGroup = async (groupId, data) => {
  try {
    const resp = await axios.post(BASE_URL + `group/addUsers/${groupId}`, data);
    return resp.data;
  } catch (error) {
    console.log(error);
    return {
      user: undefined,
      msg: error.response.data.msg,
    };
  }
};

export const createAndAddMultipleUsersToUsersList = async (
  groupId,
  ownerId,
  data,
) => {
  try {
    const resp = await axios.post(
      BASE_URL + `group/addUsersList/${groupId}/${ownerId}`,
      data,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return {
      user: undefined,
      msg: error.response.data.msg,
    };
  }
};

export const createAndAddCombinedUsersData = async (groupId, data) => {
  try {
    const resp = await axios.post(
      BASE_URL + `group/addCombinedUsers/${groupId}`,
      data,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return {
      success: false,
      msg: error.response?.data?.msg || "Error uploading data",
    };
  }
};

//TIMROL
export const getUserTIMRol = async (groupId, userId) => {
  try {
    const resp = await axios.get(
      BASE_URL + `timRol/user/${userId}/group/${groupId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const updateTimRol = async (userId, groupId, data, ownerId) => {
  try {
    const url = ownerId
      ? BASE_URL + `timRol/find/${userId}/${groupId}/${ownerId}`
      : BASE_URL + `timRol/find/${userId}/${groupId}`;
    const resp = await axios.put(url, data);
    return resp.data;
  } catch (error) {
    //TO DO: HANDLE ERROR
    return {
      user: undefined,
      msg: error.response?.data?.msg,
    };
  }
};
//ASSESSMENT 360
export const getUsersEval = async (userId, groupId) => {
  try {
    const resp = await axios.get(
      BASE_URL + `360/userList/${userId}/group/${groupId}`,
    );
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

//PDF
export const generatePDF = async () => {
  try {
    const resp = await axios.get(BASE_URL + `pdf/assessment`);
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `test.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    return true;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

//CLIENT SETUP
export const getGroupBySetupToken = async (token) => {
  try {
    const resp = await axios.get(BASE_URL + `group/setup/${token}`);
    return resp.data;
  } catch (error) {
    return { group: undefined, msg: error.response?.data?.msg || "Error" };
  }
};

export const generateSetupToken = async (groupId) => {
  try {
    const resp = await axios.post(BASE_URL + `group/setup/generate/${groupId}`);
    return resp.data;
  } catch (error) {
    return { setupToken: undefined, msg: error.response?.data?.msg || "Error" };
  }
};

export const getSetupReviewees = async (token) => {
  try {
    const resp = await axios.get(BASE_URL + `group/setup/${token}/reviewees`);
    return resp.data;
  } catch (error) {
    return { reviewees: [], msg: error.response?.data?.msg || "Error" };
  }
};

export const createSetupReviewee = async (token, data) => {
  try {
    const resp = await axios.post(BASE_URL + `group/setup/${token}/reviewee`, data);
    return resp.data;
  } catch (error) {
    return { user: undefined, msg: error.response?.data?.msg || "Error" };
  }
};

export const getSetupReviewers = async (token, ownerId) => {
  try {
    const resp = await axios.get(BASE_URL + `group/setup/${token}/reviewers/${ownerId}`);
    return resp.data;
  } catch (error) {
    return { reviewers: [], msg: error.response?.data?.msg || "Error" };
  }
};

export const createSetupReviewer = async (token, ownerId, data) => {
  try {
    const resp = await axios.post(BASE_URL + `group/setup/${token}/reviewer/${ownerId}`, data);
    return resp.data;
  } catch (error) {
    return { user: undefined, msg: error.response?.data?.msg || "Error" };
  }
};

export const submitSetup = async (token, data) => {
  try {
    const resp = await axios.post(BASE_URL + `group/setup/${token}/submit`, data);
    return resp.data;
  } catch (error) {
    return { msg: error.response?.data?.msg || "Error", error: true };
  }
};

export const getGroup360ResponsesExport = async (groupId, slug) => {
  try {
    const resp = await axios.get(BASE_URL + `answer/360/export/${groupId}/${slug}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const send360Report = async (groupId, data) => {
  try {
    const resp = await axios.post(BASE_URL + `group/send360Report/${groupId}`, data);
    return resp.data;
  } catch (error) {
    return { msg: error.response?.data?.msg || "Error", error: true };
  }
};

export const sendLaunchEmails = async (groupId, data) => {
  try {
    const resp = await axios.post(BASE_URL + `group/sendLaunchEmails/${groupId}`, data);
    return resp.data;
  } catch (error) {
    return { msg: error.response?.data?.msg || "Error", error: true };
  }
};

export const sendReminderEmails = async (groupId, data) => {
  try {
    const resp = await axios.post(BASE_URL + `group/sendReminderEmails/${groupId}`, data);
    return resp.data;
  } catch (error) {
    return { msg: error.response?.data?.msg || "Error", error: true };
  }
};

export const sendTIMLaunchEmails = async (groupId, data) => {
  try {
    const resp = await axios.post(BASE_URL + `group/sendTIMLaunchEmails/${groupId}`, data);
    return resp.data;
  } catch (error) {
    return { msg: error.response?.data?.msg || "Error", error: true };
  }
};

export const sendTIMReminderEmails = async (groupId, data) => {
  try {
    const resp = await axios.post(BASE_URL + `group/sendTIMReminderEmails/${groupId}`, data);
    return resp.data;
  } catch (error) {
    return { msg: error.response?.data?.msg || "Error", error: true };
  }
};

export const updateGroupDeadline = async (groupId, data) => {
  try {
    const resp = await axios.put(BASE_URL + `group/updateDeadline/${groupId}`, data);
    return resp.data;
  } catch (error) {
    return { msg: error.response?.data?.msg || "Error", error: true };
  }
};

export const updateRevieweeDeadline = async (ownerId, groupId, data) => {
  try {
    const resp = await axios.put(BASE_URL + `group/updateRevieweeDeadline/${ownerId}/${groupId}`, data);
    return resp.data;
  } catch (error) {
    return { msg: error.response?.data?.msg || "Error", error: true };
  }
};

//EMAIL TEMPLATES
export const getAllEmailTemplates = async () => {
  try {
    const resp = await axios.get(BASE_URL + "emailTemplate/");
    return resp.data;
  } catch (error) {
    console.log(error);
    return { templates: [] };
  }
};

export const getEmailTemplate = async (key) => {
  try {
    const resp = await axios.get(BASE_URL + `emailTemplate/${key}`);
    return resp.data;
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const updateEmailTemplate = async (key, data) => {
  try {
    const resp = await axios.put(BASE_URL + `emailTemplate/${key}`, data);
    return resp.data;
  } catch (error) {
    return { msg: error.response?.data?.msg || "Error updating template", error: true };
  }
};

export const resetEmailTemplate = async (key) => {
  try {
    const resp = await axios.post(BASE_URL + `emailTemplate/reset/${key}`);
    return resp.data;
  } catch (error) {
    return { msg: error.response?.data?.msg || "Error resetting template", error: true };
  }
};

export const sendPreviewEmail = async (key, email) => {
  try {
    const resp = await axios.post(BASE_URL + `emailTemplate/sendPreview/${key}`, { email });
    return resp.data;
  } catch (error) {
    return { msg: error.response?.data?.msg || "Error sending preview", error: true };
  }
};

// REPORT SHARES

export const createShares = async (data) => {
  try {
    const resp = await axios.post(BASE_URL + "share", data);
    return resp.data;
  } catch (error) {
    return { error: true, msg: error.response?.data?.msg || "Failed to create shares" };
  }
};

export const listShares = async ({ group, assessment }) => {
  try {
    const params = new URLSearchParams();
    if (group) params.set("group", group);
    if (assessment) params.set("assessment", assessment);
    const resp = await axios.get(BASE_URL + `share?${params.toString()}`);
    return resp.data;
  } catch (error) {
    return { error: true, msg: error.response?.data?.msg || "Failed to load shares", shares: [] };
  }
};

export const revokeShare = async (id, data = {}) => {
  try {
    const resp = await axios.delete(BASE_URL + `share/${id}`, { data });
    return resp.data;
  } catch (error) {
    return { error: true, msg: error.response?.data?.msg || "Failed to revoke share" };
  }
};

export const resendShare = async (id, data = {}) => {
  try {
    const resp = await axios.post(BASE_URL + `share/${id}/resend`, data);
    return resp.data;
  } catch (error) {
    return { error: true, msg: error.response?.data?.msg || "Failed to resend share" };
  }
};

export const redeemShareToken = async (token) => {
  try {
    const resp = await axios.get(BASE_URL + `share/redeem/${token}`);
    return resp.data;
  } catch (error) {
    return { error: true, msg: error.response?.data?.msg || "Invalid or expired link" };
  }
};

export const redeemShareCode = async (email, code) => {
  try {
    const resp = await axios.post(BASE_URL + "share/redeem", { email, code });
    return resp.data;
  } catch (error) {
    return {
      error: true,
      status: error.response?.status,
      msg: error.response?.data?.msg || "Invalid email or code",
    };
  }
};
